export const BASE_URL = "https://nexon.eazotel.com";
// export const BASE_URL = "http://127.0.0.1:5000";

export const GIAN_URL = "https://gian-1eve.onrender.com/api/v1";
// export const GIAN_URL = "http://localhost:8000/api/v1";
